import { useEffect, useState } from "react"
import { useSelector } from "react-redux"

export function useCanEdit(bypass) {
    // const activeCase = useSelector(state => state.case.activeCase) 
    // // master disable/enable based on master status
    // const [masterDisable, setMasterDisable] = useState(false)
    // useEffect(() => {
    //     if (!bypass) {
    //         if (isCaseArchived(activeCase?.case?.master_status_id)) {
    //             setMasterDisable(true)
    //         }
    //     }
    // }, [activeCase?.case?.master_status_id])


    // return masterDisable

    const editPerm = useSelector(state => state.permissions.editPermissions)

    return true
}

export function useCanEditArchived(bypass) {
    const activeCase = useSelector(state => state.case.activeCase)
    const editPerm = useSelector(state => state.permissions.editPermissions)
    if (activeCase && activeCase?.case?.master_status_id == 0) {
        
        if (bypass) {
            return false
        }
        return !editPerm.case_update_archived
    }

    return false
    
    // const editPerm = useSelector(state => state.permissions.editPermissions)
    // if (bypass) {
    //     return false
    // }
    // return !editPerm.case_update_archived
}

export function useCanChangeArchivedUnarchived() {
    const editPerm = useSelector(state => state.permissions.editPermissions)
    return !editPerm.case_archive_unarchive
}

export function isCaseArchived(masterStatusId) {

    // if case status is "Archived" == 0 then disable all fields 
    if (masterStatusId == 0) {
        return true
    }

    return false
}

export function useUserTabEditPermissionDisabled(type, isUM) {
    const editPerm = useSelector(state => state.permissions.editPermissions)

    let getType = isUM ? 'case_um' : type

    // excluded:::: case generateCaseSummaryPDF, documents, notes, procodocs

    switch (getType) {
        //case summary
        case 'case_summary':
            return !editPerm.summary_edit

        //patient 
        case 'patient_edit':
            return editPerm.patient_edit  
        case 'patient_view':
            return editPerm.patient_view    
        // case   
        case 'case':
            return !editPerm.case_deatails_edit     
        case 'case_payer_type_status_edit':
            return !editPerm.case_payer_type_status_edit
        case 'case_master_status_edit':
            return !editPerm.case_master_status_edit
            
        // attorney
        case 'case_attorney':
            return !editPerm.attorney_edit
        case 'case_attorney_assign':
            return !editPerm.attorney_assign 
        // liability
        case 'case_liability':
            return !editPerm.liability_edit 
        case 'case_liability_assign':
            return !editPerm.liability_assign 
        case 'liability_confirmed_with_carrier':
            return !editPerm.liability_confirmed_with_carrier
        case 'liability_edit_confirmed_limits':
            return !editPerm.liability_edit_confirmed_limits
        // medpay
        case 'case_mp_pip_um':
            return !editPerm.medpay_pip_edit
        // major med
        case 'case_major_med':
            return !editPerm.major_med_edit
        case 'case_major_med_assign':
            return !editPerm.major_med_assign
        // UM
        case 'case_um':
            return !editPerm.um_edit
        // crime victim
        case 'case_crime_victim':
            return !editPerm.crime_victim_edit
        // worker comp
        case 'case_worker_comp':
            return !editPerm.workers_comp_edit
        case 'case_worker_comp_departments':
            return !editPerm.workers_comp_edit
        case 'case_worker_comp_dep_surgery_steps':
            return !editPerm.workers_comp_edit
        case 'case_worker_comp_dep_services':
            return !editPerm.workers_comp_edit
        case 'case_worker_comp_dep_surgeries':
            return !editPerm.workers_comp_edit
            
        case 'case_worker_comp_assign':
            return !editPerm.workers_comp_assign
        // services
        case 'case_services':
            return !editPerm.services_edit

        // surgeries
        case 'case_surgeries':
            return !editPerm.asc_edit
        case 'case_surgeries_edit_final_financial_aprove':
            return !editPerm.asc_edit_final_financial_approve

        // transportation
        // case 'case_transportation':
        //     return !editPerm.transportation_edit
        case 'transportation_deny_further_trips':
            return editPerm.transportation_deny_further_trips        
        case 'transportation_create_trip':
            return editPerm.transportation_create_trip
        case 'transportation_create_trip_manual':
            return editPerm.transportation_create_trip_manual
        case 'transportation_topup_funds':
            return editPerm.transportation_topup_funds

        // negotiation
        case 'case_negotiation':
            return !editPerm.negotiation_edit
        case 'edit_escalation':
            return !editPerm.edit_escalation
        // sos
        case 'case_sos':
            return !editPerm.sos_edit
        case 'sos_view_cost_of_goods':
            return editPerm.sos_view_cost_of_goods
        case 'sos_view_price':
            return editPerm.sos_view_price
        // selfpay
        case 'case_selfpay':
            return !editPerm.self_pay_edit

        // insurance globals create
        case 'create_insurance':
            return editPerm.insurance_carrier_create
        case 'insurance_carrier_create_locations':
            return editPerm.insurance_carrier_create_location
        case 'insurance_carrier_create_adjusters':
            return editPerm.insurance_carrier_create_adjuster
        case 'insurance_carrier_create_nurses':
            return editPerm.insurance_carrier_create_nurse

        // insurance edit
        case 'insurance_carrier_edit_locations':
            return editPerm.insurance_carrier_edit_location
        case 'insurance_carrier_edit_adjusters':
            return editPerm.insurance_carrier_edit_adjuster
        case 'insurance_carrier_edit_nurses':
            return editPerm.insurance_carrier_edit_nurse


        // attorney globals create
        case 'create_attorney':
            return editPerm.law_firm_create
        case 'law_firm_create_locations':
            return editPerm.law_firm_location_create
        case 'law_firm_create_attorneys':
            return editPerm.law_firm_attorney_create
        case 'law_firm_create_case_managers':
            return editPerm.law_firm_case_manager_create

        // attorney edit
        case 'law_firm_edit_locations':
            return editPerm.law_firm_location_edit
        case 'law_firm_edit_attorneys':
            return editPerm.law_firm_attorney_edit   
        case 'law_firm_edit_case_managers':
            return editPerm.law_firm_case_manager_edit


        // related patients
        case 'related_patients_edit':
            return editPerm.related_patient_edit


        // appointments
        case 'appointments_view':
            return editPerm.appointments_view

        // alert resolve
        case 'alert_resolve':
            return editPerm.alert_resolve

        
        // practices
        case 'case_practice':
            return !editPerm.practice_patient_status_edit
        case 'case_aica_department_status':
            return !editPerm.practice_department_status_edit
        case 'practice_amounts_view':
            return editPerm.practice_amounts_view
        case 'practice_view_transfer':
            return editPerm.practice_view_transfer
        case 'practice_add_transfer':
            return editPerm.practice_add_transfer
        case 'practice_complete_transfer':
            return editPerm.practice_complete_transfer
        
            
        // lien
        case 'lien_edit':
            return !editPerm.lien_edit
        case 'lien_create_from_document':
            return !editPerm.lien_create_from_document
        case 'lien_book_page_edit':
            return editPerm.lien_book_page_edit
        case 'lien_do_not_lien':
            return !editPerm.lien_do_not_lien

        // ProcoDocs
        case 'procodocs_documents_chat':
            return editPerm.procodocs_documents_chat
        case 'procodocs_documents_upload':
            return editPerm.procodocs_documents_upload
        case 'procodocs_documents_update':
            return editPerm.procodocs_documents_update
        case 'procodocs_documents_delete':
            return editPerm.procodocs_documents_delete
        case 'procodocs_documents_restore':
            return editPerm.procodocs_documents_restore
        

        case 'documents_delete':
            return editPerm.documents_delete
        case 'notes_tasks_delete':
            return editPerm.notes_tasks_delete
        case 'documents_restore':
            return editPerm.documents_restore
        case 'documents_hard_delete':
            return editPerm.documents_hard_delete
        case 'procodocs_documents_hard_delete':
            return editPerm.procodocs_documents_hard_delete

        //history history_view
        case 'history_view':
            return editPerm.history_view

        //work q permissions
        case 'work_queues_export':
            return editPerm.work_queues_export
        case 'work_queues_totals':
            return editPerm.work_queues_totals   
        case 'work_queues_stats_export':
            return editPerm.work_queues_stats_export
        
        default:
            break;
    }
    return false
}


